import { render, staticRenderFns } from "./BulkUpdateCountryOfOrigin.vue?vue&type=template&id=5b4e3616&scoped=true&"
import script from "./BulkUpdateCountryOfOrigin.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateCountryOfOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e3616",
  null
  
)

export default component.exports